<template>
  <canvas :height="height || '200'" :width="width" :id="this.id"></canvas>
</template>

<script>
import Chart from "chart.js";
export default {
  props: ["id", "type", "labels", "dataChart", "height", "description", "subtitlePosition", "dark", "backgroundColor", "width"],
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    dados() {
      this.montaChart();
    }
  },
  methods: {
    unmountChart() {
      this.chart.destroy();
    },
    montaChart() {
      var tela = document.getElementById(this.id).getContext("2d");
      this.chart = new Chart(tela, {
        type: this.type,
        data: {
          labels: this.labels,
          datasets: [
            {
              label: this.description,
              backgroundColor: this.backgroundColor,
              borderColor: this.dark ? '"orange"' : 'orange',
              data: this.dataChart,
            },
          ]
        },
        options: {
          legend: {
            display: true,
            labels: {
              fontColor: this.dark ? 'orange' : "orange",
            },
            position: this.subtitlePosition || 'right' // Coloque a legenda na parte inferior
          },
          responsive: true,
        },
      });
    }
  },
  mounted() {
    this.montaChart();
  }
};
</script>
